import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import './App.css';
import './DarkMode.css';
import { ThemeProvider } from './ThemeContext';
import { GyerekekProvider } from './GyerekekContext'; 
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Temakork from './components/Temakork';
import Szuloknek from './components/Szuloknek';
import ProfilOldal from './components/ProfilOldal';
import Bejelentkezes from './components/Bejelentkezes';
import VedettUtvonal from './components/VedettUtvonal';
import Footer from './components/Footer';
import SegelyvonalakOldal from './components/SegelyvonalakOldal';
import PartnerekOldal from './components/PartnerekOldal';
import JelvenyAblak from './components/JelvenyAblak';
import AdatkezelesiTajekoztato from './components/AdatkezelesiTajekoztato';
import Aszf from './components/Aszf';
import Fogalmak from './components/Fogalmak';

// A /belepes route-hoz: bejelentkezés/regisztráció után visszairányít a főoldalra
// (vagy oda, ahonnan a felhasználót idehoztuk).
function BelepesOldal() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: 'calc(100vh - 88px)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '2rem', background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
    }}>
      <Bejelentkezes onKesz={() => navigate('/')} />
    </div>
  );
}

function App() {
  const [felhasznalo, setFelhasznalo] = useState(null);
  const [tolt, setTolt] = useState(true);

  useEffect(() => {
    const leiratkozas = onAuthStateChanged(auth, (user) => {
      setFelhasznalo(user);
      setTolt(false);
    });
    return leiratkozas;
  }, []);

  const kijelentkezes = () => signOut(auth);

  if (tolt) return (
    <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)'}}>
      <div style={{fontSize: '64px'}}>⏳</div>
    </div>
    
  );

 return (
    <ThemeProvider>
      <GyerekekProvider felhasznalo={felhasznalo}>
        <Router>
          <Navbar felhasznalo={felhasznalo} kijelentkezes={kijelentkezes} />
          <JelvenyAblak />
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/belepes" element={<BelepesOldal />} />
            <Route path="/temakork" element={<Temakork felhasznalo={felhasznalo} />} />
            <Route path="/szuloknek" element={
              <VedettUtvonal><Szuloknek /></VedettUtvonal>
            } />
            <Route path="/adatkezeles" element={<AdatkezelesiTajekoztato />} />
            <Route path="/aszf" element={<Aszf />} />
            <Route path="/profil" element={
              <VedettUtvonal><ProfilOldal felhasznalo={felhasznalo} /></VedettUtvonal>
            } />
            <Route path="/segelyvonalak" element={<SegelyvonalakOldal />} />
            <Route path="/partnereink" element={<PartnerekOldal />} />
            <Route path="/fogalmak" element={<Fogalmak />} />
          </Routes>
          <Footer/>
        </Router>
      </GyerekekProvider>
    </ThemeProvider>
  );
}

export default App;